export const PN_BACKGROUND = '#B55A25';
export const HELPED_KEY = 'PN HELPED';
export const SEEN_SOLO_OPTIONS_KEY = 'PN SEEN SOLO OPTIONS';
export const SEEN_AI_OPTIONS_KEY = 'PN SEEN AI OPTIONS';
export const SEEN_FRIEND_OPTIONS_KEY = 'PN SEEN FRIEND OPTIONS';
export const PN_RED = '#C30000';
export const PN_YELLOW = '#FF7800';
export const PN_GREEN = '#157D04';
export const PN_PURPLE = '#CF00BE';
export const PN_CYAN = '#00BECF';
export const PN_BLUE = '#1A78C0';
export const PN_INDIGO = '#7200FF';
export const PN_COLORS = [PN_RED, PN_YELLOW, PN_GREEN, PN_PURPLE, PN_BLUE, PN_INDIGO];
export const PN_SHAPES = ['square', 'club', 'triangle', 'circle', 'rhombus', 'heart', 'star', 'crescent', 'cross'];
export const TO_PILE = 'TO PILE';
export const IN_PILE = 'IN PILE';
export const TO_TRAY = 'TO TRAY';
export const IN_TRAY = 'IN TRAY';
export const TO_PLAY = 'TO PLAY';
export const IN_PLAY = 'IN PLAY';
export const INVALID_ACTION_NO_MATCH = 'Any two adjacent pieces must share either the same shape or the same color (but not both).';
export const INVALID_ACTION_PAIRS = 'You cannot break more pairs than you create.';
export const INVALID_ACTION_ORPHAN = 'You cannot leave any pieces orphaned.';
export const INVALID_ACTION_PIECES_IN_TRAY =
  'Playing solo, you cannot proceed with playable pieces still in the tray. You may have to scroll to find a valid spot.';
export const OPTIONS_KEY = 'PN OPTIONS';
export const YOUTUBE_PN = 'https://youtu.be/0zfQZh8JSNc';
